import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { captureMessage } from "@sentry/react";
import type React from "react";

import { messages } from "./locales/en/messages.po";

// Load the catalog before any other module evaluates. Many modules call `t` at module
// scope (field configs, PASSWORD_VALIDATION_RULES); before the catalog loads, those calls
// return the message ID (e.g. "bU39dx") and keep it for the page's lifetime.
i18n.loadAndActivate({ locale: "en", messages });

const reportedMissingIds = new Set<string>();
i18n.on("missing", ({ id, locale }) => {
  if (reportedMissingIds.has(id)) return;
  reportedMissingIds.add(id);
  // Defer so misses during startup module evaluation report after initSentry() runs.
  setTimeout(() => {
    captureMessage(`Missing translation: ${id}`, {
      level: "warning",
      tags: { "i18n.locale": locale, "i18n.message_id": id },
    });
  }, 0);
});

export const LinguiProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <I18nProvider i18n={i18n}>{children}</I18nProvider>
);

export default i18n;
